import React from 'react';
import { useParams } from 'react-router-dom';
import { useContent } from '../ContentContext';
import PageRenderer, { PageData } from '../components/PageRenderer';
import NotFound from '../components/NotFound';

const DynamicPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const { content } = useContent();

  // content.pages may not exist until the API is fetched
  const pages: PageData[] = (content as any).pages || [];
  const page = pages.find(p => p.slug === slug);

  if (!page) {
    return <NotFound />;
  }

  return <PageRenderer page={page} />;
};

export default DynamicPage;
